<!-- -->
<nav
  *ngIf="currentUser"
  class="dct-main-menu"
  [class.expanded]="isExpanded"
  (mouseenter)="isExpanded = true"
  (mouseleave)="isExpanded = false">
  <ul class="dct-menu-list">
    <li
      *ngFor="let item of navList; let i = index"
      [ngClass]="{ 'dct-has-subnav': item.childs.length > 0 }"
      (click)="toggleSubmenu(item)">
      <a
        class="dct-main-menu-item"
        [routerLink]="item.link"
        (click)="setActive(i)"
        [routerLinkActive]="['active']"
        >
        <!-- [ngClass]="{ active: activeIndex === i }" -->
        <div
          *ngIf="item.svg"
          class="dct-menu-icon"
          [replaceSvg]="icons[item.svg]"></div>

        <span class="dct-nav-text">{{ item.name | translate }}</span>

        <em
          [ngClass]="{
            'd-none': item.childs.length === 0,
            expanded: item.expanded,
          }"
          class="arraw">
          <i class="fa fa-chevron-right"></i>
        </em>
      </a>

      <ul *ngIf="item.childs.length && item.expanded">
        <li *ngFor="let child of item.childs">
          <a
            [routerLink]="child.link"
            [routerLinkActive]="['active']"
            [attr.title]="child.title | translate">
            <div
              *ngIf="child.svg"
              class="dct-menu-icon"
              [replaceSvg]="icons[child.svg]"></div>
            <span class="dct-nav-text">{{ child.name | translate }}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>

  <ul class="dct-menu-logo">
    <li class="flex-center-all">
      <a routerLink="/dashboard">
        <div [replaceSvg]="logos.whiteBlack"></div>
      </a>
    </li>
    <li class="flex-center-all">
      <span class="version">V 1.0</span>
    </li>
  </ul>
</nav>
